import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { ContatoConcessionaria } from '../../../containers'

const Contato = (props) => {
  const { concessionaria } = props
  return (
    <div>
      <Switch>
        <Route
          exact path='/concessionarias/:concessionariaId/contatos'
          render={({match}) => (
            <ContatoConcessionaria.Index
              concessionaria={concessionaria}
              match={match}
            />
          )}>
        </Route>
        <Route
          exact path='/concessionarias/:concessionariaId/contatos/new'
          render={({match}) => (
            <ContatoConcessionaria.Form
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
        <Route
          exact path='/concessionarias/:concessionariaId/contatos/:id/edit'
          render={({match}) => (
            <ContatoConcessionaria.Form
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
        <Route
          exact path='/concessionarias/:concessionariaId/contatos/:id'
          render={({match}) => (
            <ContatoConcessionaria.Show
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
      </Switch>
    </div>
  )
}

Contato.propTypes = {
  concessionaria: PropTypes.object.isRequired,
}

export default Contato
